<template>
  <div class="table table-hover table-condensed">
    <b-row class="thead py-0">
      <div :class="rowHeaderClass && rowHeaderClass(null)">
      </div>
      <template v-for="(col, index) in columns">
        <slot name="column-header" :col="col" :index="index">
          <div :class="columnClass(col)">{{ formatColumnHeader(col) }}</div>
        </slot>
      </template>
    </b-row>
    <div class="tbody">
      <template v-for="row in value.children">
        <table-report-row :row="row" :columns="columns" :header-class="rowHeaderClass">
          <template v-slot:value="{ row: r, col: c, index: i }">
            <slot name="value" :row="r" :col="c" :index="i"><!--
              <b-col :class="valueClass(r, c) + ' ' + columnClass(c)">
                {{ formatValue(r, c) }}
              </b-col>
            --></slot>
          </template>
        </table-report-row>
      </template>
    </div>
  </div>
</template>
<script>
import { number2text, subarray } from 'core/utils';

export function columnClass(col) {
  return "col-1";
}

export function valueClass(row, col) {
  const value = this.value.values[row.name][col.name];
  if (typeof value === 'number') {
    let ret = 'text-right';
    if (value && value < 0) {
      ret += ' text-danger';
    }
    return ret;
  }
  return '';
}

export function formatColumnHeader(col) {
  return col.translation || col.name;
}

export function formatValue(row, col) {
  const value = this.value.values[row.name][col.name];
  //console.log('row', row, 'col', col, 'value', value);
  if (typeof value === 'number') {
    return number2text(value, 2);
  }
  return value;
}

export default {
  props: {
    value: {
      type: Object
    },

    columnClass: {
      type: Function,
      default: columnClass
    },

    valueClass: {
      type: Function,
      default: valueClass
    },

    rowHeaderClass: {
      type: Function,
      default: undefined,
    },

    formatColumnHeader: {
      type: Function,
      default: formatColumnHeader
    },

    formatValue: {
      type: Function,
      default: formatValue
    },

    firstColumn: {
      type: Number,
      default: 0
    },

    lastColumn: {
      type: Number,
      default: undefined
    },
  },

  computed: {
    columns() {
      const cols = Object.values(this.value.columns);
      const ret = subarray(cols, this.firstColumn, this.lastColumn);
      //console.log(this.firstColumn, this.lastColumn, 'columns', ret);
      return ret;
    }
  }
}
</script>
